import {useContext, useEffect, useState} from 'react'
import {ThemeContext} from '../context'
import axios from "axios";
import {API_URL} from "../environment";

const client = axios.create({
    baseURL: API_URL
})

export function useFetch<T>(url) {
    const [data, setData] = useState<T>([] as T)
    const [isLoading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        if (!url) return
        setLoading(true)

        function fetchData() {
            client.get<T>(url)
                .then(response => setData(response?.data))
                .catch(error => setError(true))
                .finally(() => setLoading(false))
        }

        fetchData()
    }, [url])

    return {isLoading, data, error}
}

export function useTheme() {
    const {theme, toggleTheme} = useContext(ThemeContext)
    return {theme, toggleTheme}
}
